module.exports = __webpack_public_path__ + "img/in-screen-side.ba10a123.png";